import { render } from "./IconSettingsProfile.vue?vue&type=template&id=59512710&scoped=true&ts=true"
import script from "./IconSettingsProfile.vue?vue&type=script&lang=ts"
export * from "./IconSettingsProfile.vue?vue&type=script&lang=ts"

import "./IconSettingsProfile.vue?vue&type=style&index=0&id=59512710&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59512710"]])

export default __exports__